/**
 * @desc 分数排名
 */
import './scoresRanking.scss';
import React from 'react';
import cns from 'classnames';
import { Progress } from 'antd';

export default function ScoresRanking({ className, data = [], extra, ...others }) {

    return (
        <table className={cns('score-rank', className)} {...others}>
            <tbody>
            {
                data && data.map((d, i) => {
                    return (
                        <tr key={d.name}>
                            <td className="score-index">{i + 1}</td>
                            <td className="score-name">{d.name}</td>
                            <td className="score-progress">
                                <Progress strokeWidth={14} percent={d.value * 100} showInfo={false} />
                                <p className="score-extra">{extra && extra(d)}</p>
                            </td>
                            <td className="score-value">{d.value} 分</td>
                        </tr>
                    );
                })
            }
            </tbody>
        </table>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/scoresRanking/ScoresRanking.jsx